import React from 'react';
import { Link } from 'react-router-dom';
import { FaBars, FaTimes } from 'react-icons/fa';
import { NavItemsList } from './NavItemsList';
import Dropdown from './Dropdown';
import '../CSS/Header.css';

//A parent component holds a single or multiple dropdown menus. 


class Header extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            navRef: '',
            sidebar: false,
            dropdown: '',
        };
        this.showSidebar = this.showSidebar.bind(this);
        this.closeSidebar = this.closeSidebar.bind(this);
        this.toggleDropdown = this.toggleDropdown.bind(this);
        this.hideDropdown = this.hideDropdown.bind(this);
    }


    showSidebar() {
        this.setState({
            navRef: 'responsive-nav',
            sidebar: true
        });
    }

    closeSidebar() {
        this.setState({
            navRef: '',
            sidebar: false
        });
    }

    toggleDropdown(name) {
        // console.log(this.state.dropdown)
        this.setState({ dropdown: name });
    }

    hideDropdown() {
        this.setState({ dropdown: '' });
    }


    render() {
        return (
            <div className='navbar'>
                {/* <img src={`https://static.igem.wiki/teams/4241/wiki/amped-small.png`} alt='' className='img-amped-header'/> */}
                <Link to={'/'} className='pjname-link'>
                    <h2 className='pjname-header'>AMPed</h2>
                </Link>

                <div className={'div-link ' + this.state.navRef} >
                    {NavItemsList.map((item, index) => {
                        if (item.id < 6) {
                            return (
                                <div
                                    key={item.state +index}
                                    className={'nav-item '}
                                    onMouseEnter={() => this.toggleDropdown(item.state)}
                                    onMouseLeave={() => this.hideDropdown(item.state)}
                                >
                                    <button className='link-header'> {item.title}</button>
                                    {this.state.dropdown === item.state &&
                                        <Dropdown
                                            id={item.id}
                                            sidebar={this.state.sidebar}
                                        />}
                                </div>
                            )
                        }
                        else {
                            return (
                                <div
                                    key={item.state +index}
                                    className={'nav-item '}
                                >
                                    <Link to={item.link} className='link-header'> {item.title}</Link>
                                </div>
                            )

                        }

                    })}

                    <button onClick={this.closeSidebar} className='nav-close-btn'>
                        <FaTimes />
                    </button>
                </div>
                <button onClick={this.showSidebar} className='nav-open-btn'>
                    <FaBars />
                </button>
            </div>
        )
    }
}

export default Header;